
<b-nav
  v-if="isOneDriveEnabled"
  class="mb-4"
  :class="{ [customClass]: !!customClass }"
  pills
  small
>
  <b-nav-item :active="isActive('documents.list')" :to="documentsTo">
    <Icon icon="hdd" size="14" class="mr-2" />
    {{ __('documents.system') }}
  </b-nav-item>
  <b-nav-item
    :active="isActive('driveDocuments.list')"
    :to="driveDocumentsTo"
  >
    <Icon icon="cloud" size="14" class="mr-2" />
    {{ __('documents.one-drive') }}
  </b-nav-item>
</b-nav>
